import React from 'react';
import { ShareLinkFieldType, ShareLinkFormType } from '../../form/link-config-form.factory';

import { useFormikContext } from 'formik';
import { ShareIndexing } from '../../form/fields/indexing';

export const ShareConfigIndexingPanel = () => {
  const { values, setFieldValue } = useFormikContext<ShareLinkFormType>();

  const onFieldChange = (payload: ShareLinkFieldType<unknown>) => {
    setFieldValue(payload.field, payload.value);
  };

  return (
    <div className='flex flex-col space-y-4 py-6'>
      <ShareIndexing
        indexing={{ field: 'disable_indexing', value: !values.disable_indexing }}
        onFieldChange={onFieldChange}
      />
    </div>
  );
};
